<template>
    <div class="rec_box" @click="gotoDetail(item.goods_type,item.id,item.app_name,item.icon,item.app_id,item.server_id,item.server_name)">
        <div class="icon">
            <van-image class="first_pic" :src="item.first_pic" v-if="item.first_pic" />
            <van-image :class="{'goods_icon': item.goods_type == 1}" :src="item.icon" v-else/>
        </div>
        <div class="cont">
            <div v-if="item.goods_type != 1">
               <p class="tit"> <span>一口价</span>
                {{ item.goods_name }}</p>
                <p class="role_info" v-if="roleInfoList(item.role_attr).length">
                    <span v-for="(ri, idx) in roleInfoList(item.role_attr)" :key="idx" class="item">
                        {{ ri.name }}:{{ ri.value }}
                    </span>
                </p>
            </div>
            <div class="tit2" v-if="item.goods_type == 1">
                <p class="type">{{ item.goods_name }}</p>
                <p class="goods_name">交易类型：{{item.goods_type_name}}</p>
            </div>
            <p class="server">
                {{item.server_name}}
                <span v-if="item.channel_name&&item.channel_name != ''&&item.app_id == 54">&nbsp;|&nbsp;{{ item.channel_name }}</span>
            </p>
        </div>
        <div class="price_want">
            <p class="price"><i>&yen;</i>{{ item.price }}</p>
            <p class="want" v-if="item.want">{{ item.want }}人想要</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'rec-box',
        props: ['item'],
        data() {
            return {}
        },
        computed: {},
        created() {},
        mounted() {},
        methods: {
            roleInfoList(item) {
                const raw = item
                if (!raw) return []
                let list = raw
                if (typeof raw === 'string') {
                    try {
                        list = JSON.parse(raw)
                    } catch (e) {
                        return []
                    }
                }
                if (!Array.isArray(list) && list && typeof list === 'object') {
                    list = Object.keys(list)
                        .sort((a, b) => Number(a) - Number(b))
                        .map(key => list[key])
                }
                if (!Array.isArray(list)) return []
                return list.filter(ri => ri && ri.name && ri.value !== undefined && ri.value !== null && ri.value !== '').slice(0, 3)
            },
            gotoDetail(goods_type,goods_id,name, icon, id,server_id,server_name) {
                if(goods_type == 1) {
                    this.$store.commit('setGameInfo', {
                      name,
                      icon,
                      id
                    })
                    this.$store.commit('bindHomeServer',{
                      server_id,
                      server_name
                    })
                    this.$router.push({
                        name: 'order',
                        query: {
                            id: goods_id
                        }
                    })
                }else {
                    this.$router.push({
                        name: 'acc.goods',
                        query: {
                            goods_id
                        }
                    })
                }
            },
        },
        watch: {},
    }
</script>

<style lang="less" scoped>
    .rec_box {
        position: relative;
        // display: flex;
        align-items: center;
        height: 9.4rem;
        border: 1px solid #FFDCCB;
        border-radius: 1rem;
        margin-bottom: 1rem;
        padding: 1.2rem 1rem;
        cursor: pointer;
        transition: all ease .5s;
        &:hover {
            transform: scale(1.05);
        }
        .icon {
            float: left;
            width: 7rem;
            height: 7rem;
            border-radius: 1.2rem;
            margin-right: 1.2rem;
            background-color: #515151;
            overflow: hidden;
            display: flex;
            justify-content: center;
            align-items: center;
            .van-image {
                width: 100%;
                height: 100%;
               
                &.goods_icon {
                    width: 60%;
                    height: 60%;
                }
            }
        }
        .cont {
            max-width: calc(100% - 9rem);
            float: left;
            flex: 1;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .tit {
                font-size: 1.4rem;
                line-height: 1.5;
                color: #000;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                font-weight: 700;
                margin-bottom: 0.3rem;
                span {
                    display: inline-block;
                    font-size: 1.2rem;
                    height: 1.6rem;
                    line-height: 1.6rem;
                    padding: 0 .8rem;
                    background-color: #ffc933;
                    transform: scale(0.9);
                    transform-origin: 0 0;
                    color: #fff;
                    border-radius: 0.2rem;
                    font-weight: 400;
                }
            }
            .tit2 {
                font-size: 1.4rem;
                font-weight: 700;
                line-height: 2.2rem;
                .goods_name {
                    font-weight: normal;
                }
            }
            .server {
                font-size: 1.3rem;
                color: #999;
            }
        }
        .price_want {
            position: absolute;
            bottom: 1rem;
            right: 1rem;
            height: 100%;
            width: 8rem;
            margin-left: 1rem;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            p {
                text-align: end;
            }
            .price {
                font-size: 1.6rem;
                color: #EF4D3D;
                font-weight: 700;
                white-space: nowrap;
                i {
                    font-weight: normal;
                    display: inline-block;
                    font-size: 1.2rem;
                    transform: translateY(-0.1rem);
                    margin-right: 0.02rem;
                }
            }
            .want {
                margin-top: 1.1rem;
                font-size: 1.2rem;
                color: #999;
            }
        }
    }
    .role_info {
        margin-top: 0.2rem;
        display: inline-flex;
        flex-wrap: wrap;
        align-items: center;
        white-space: nowrap;
        color: var(--theme);
        border: 1px solid var(--theme);
        padding: .1rem .8rem .15rem;
        border-radius: .2rem;
        margin-bottom: .35rem;
        .item {
            margin-right: 1rem;
            &:last-child {
                margin-right: 0;
            }
        }
        span {
            color: var(--theme);
        }
    }
</style>
